import { render } from "./MotPresident.vue?vue&type=template&id=eed019b6&scoped=true"
const script = {}

import "./MotPresident.vue?vue&type=style&index=0&id=eed019b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eed019b6"]])

export default __exports__